let palette = {};

export default palette;
